
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.006 16H6c-3.308 0-6-2.692-6-6s2.692-6 6-6c1.602 0 3.137.643 4.26 1.775A3.014 3.014 0 0 1 13 4a3.004 3.004 0 0 1 2.822 4.017A3.999 3.999 0 0 1 20 12.007a3.999 3.999 0 0 1-3.994 3.994zM6 5c-2.757 0-5 2.243-5 5s2.243 5 5 5h10.006C17.657 15 19 13.657 19 12.006a2.997 2.997 0 0 0-4.02-2.814.5.5 0 0 1-.534-.814c.357-.376.554-.865.554-1.379 0-1.103-.897-2-2-2-.642 0-1.229.297-1.61.814-.23.312-.365.678-.388 1.057a.5.5 0 0 1-.908.257A5.008 5.008 0 0 0 6 4.999z"}})])
          )
        }
      }
    